export default __webpack_public_path__ + "static/media/cup.227c29d1.webp";